import { useRouter } from '@/routing/useAppRouter';

import { LanguageType } from '@/types/language';

/**
 * 언어 변경 hook
 */
export default function useChangeLanguage() {
  const router = useRouter();

  const currentRoute = router.asPath;

  /**
   * 언어 변경 함수
   */
  const changeLanguage = (lang: LanguageType, url?: string) => {
    const route = url || currentRoute;

    router.push(route, route, {
      locale: lang,
      scroll: url ? true : false,
    });
  };

  return changeLanguage;
}
